export const WHIP_URL = "https://customer-bbvmxi1ikmp2alzd.cloudflarestream.com/5d99d918c805a151760f0a5c9057e408k786bc2dfff16973e1242e6ca3e5d918e/webRTC/publish";

export const WORKER_URL = "https://guenter-be-worker.guenter-grimm.workers.dev";